import { ProductTypeEnum } from "src/constants/enums/productType";
import { IPlaceBetRequestArg } from "src/constants/interfaces/bet";
import TerminalPlaceBet from "./terminal";
import { storeGetConfig } from "src/stores/upperData";
import CashierPlaceBet from "./cashier";

const actionMap = {
	[ProductTypeEnum.Terminal]: TerminalPlaceBet.placeBet,
	[ProductTypeEnum.Cashier]: CashierPlaceBet.placeBet,
};

export const placeBet = (data: IPlaceBetRequestArg) => {
	const config = storeGetConfig();
	const action = actionMap[ProductTypeEnum[config.productType]];

	return action(data);
};
